//TODO: replace the axios import with the local axios file
import { v4 as uuidv4 } from "uuid";
import * as CONSTANT from "../../constants";
import { syncCartOnLogin } from "../../helpers/cartHelperMethods/syncCart";
import { attachKioskIdToSocialLoginPayloadIfSessionNotExpired, getUser, getVisitorId, safeSetCurrentUser } from "../../helpers/helperMethods";
import { Toast_Func } from "../../helpers/toast.helper";
import {isLogoutAction, resetCart } from "../../redux/slices/cartSlice";
import {resetCheckout, updateTrackOrder } from "../../redux/slices/checkoutSlice";
import { customerBusinessService } from "../../services";
import { brazeLogCustomEventLoyaltyAccountCreated, brazeLogCustomEventLoyaltySignIn, brazeSetUser } from "../../helpers/brazeHelper";
import {
  isMobileWebPlatform,
  mapSocialSignInToLoginMethod,
  trackLogin,
  type TrackLoginContext,
} from "../../analytics/pulseLogin";
import TagManager from "react-gtm-module";
import axiosNoInterceptor from "../../services/axiosNoInterceptor";
import branch from 'branch-sdk';
import { updateLoyalityPoints } from "../../redux/slices/loyaltySlice";
import { queryClient } from "../../react-query-hooks/queryClient";
import { bugSnagNotifyAPIError } from "../../helpers/bugSnagHelper";
import { openSession } from "@braze/web-sdk";
export async function loginVerification(payload,
  setOtpExpiryTime,
  dispatch,
  setDisplayOtpModal,
  setOtpModalDescription
) {
  try {
    const response = await axiosNoInterceptor.post(`${CONSTANT.CUSTOMER_MICRO_SERVICE}/send-otp`, payload);
    setOtpExpiryTime(response.data.data.expires_at);
    if (localStorage.getItem('enable_recaptcha')) {
      localStorage.removeItem("enable_recaptcha")
    }
    setOtpModalDescription(response.data.data.popup_description);
    Toast_Func({
      status: true,
      message: response?.data?.message
    });
    return true;
  } catch (error) {
    if (error?.response?.data?.enable_recaptcha) {
      dispatch({
        type: "LOGIN_ERROR",
        enable_recaptcha: error?.response?.data?.enable_recaptcha || 0
      });
      localStorage.setItem(
        "enable_recaptcha",
        error?.response?.data?.enable_recaptcha
      )
    }
    if (Boolean(error?.response?.data?.otp_popup)) {
      setOtpExpiryTime(error?.response?.data.data.expires_at);
      setDisplayOtpModal(Boolean(error?.response?.data?.otp_popup));
      setOtpModalDescription(error?.response?.data.data.popup_description);
    }
    Toast_Func({
      status: false,
      message: error?.response?.data?.message || error?.response?.data?.errors?.[0],
    });
    return false;
  }
}

export async function login(dispatch, loginPayload, cartDispatch, updateAccountStatusModal, isCheckoutLogin = false) {
  try {
    dispatch({ type: "REQUEST_LOGIN" });
    //TODO: relace post call later
    const visitorId = getVisitorId()
    const newLoginPayload = attachKioskIdToSocialLoginPayloadIfSessionNotExpired(loginPayload);
    newLoginPayload["visitor_id"] = visitorId
    const response = await axiosNoInterceptor.post(`${CONSTANT.CUSTOMER_MICRO_SERVICE}/login`, newLoginPayload);
    if (response.data.status) {
      dispatch({ type: "LOGIN_SUCCESS", payload: response.data.data });
      safeSetCurrentUser(JSON.stringify({ ...response.data.data, visitor_id: getVisitorId() }));
      cartDispatch(updateLoyalityPoints(response?.data?.data?.user_points));
      branch.setIdentity(
        `${response.data.data.id}`,
        function (err, data) {
          console.log(err, data);
        }
      );
      TagManager.dataLayer({
        dataLayer: {
          event: 'login',
          login_method: "email",
          new_user_id: response.data.data.id,
          user_email: response.data.data.email,
          user_phone: response?.data?.data?.phone
        },
      })
      if (!isCheckoutLogin) {
        trackLogin({
          userData: response.data.data,
          isItMobile: isMobileWebPlatform(loginPayload?.platform),
          loginMethod: 'Email',
          isCheckoutLogin: false,
        });
      }
      // brazeLogCustomEventLoyaltySignIn(
      //   loginPayload?.platform === "MobileWeb",
      //   "Email",
      // );
      if (!isCheckoutLogin) syncCartOnLogin(cartDispatch);
    }
  } catch (error) {
    const errorsObject = error?.response?.data?.errors;   
    const errorCode = errorsObject?.code; 
    if (errorCode) {
      const buttonText = CONSTANT.API_CODE_MESSAGES[errorCode]
      updateAccountStatusModal(
        errorsObject.header, 
        errorsObject.text, 
        errorCode,
        buttonText,
        loginPayload.email,
        true,
      );
    } else {
      Toast_Func({
        status: false,
        message: error?.response?.data?.errors?.[0]
          || error?.response?.data?.message
          || error?.response?.data?.error
          || error?.response?.data?.error?.[0]
          || "An error occured. Please try again."
      });
    }
    throw error;
  }

}

export function applyLoginSuccess(
  dispatch,
  cartDispatch,
  userData,
  isCheckoutLogin = false,
  loginMethod: "Email" | "Gmail" | "Apple" | "Auto" = "Auto",
  isItMobile = false,
) {
  // Always use the logged-in user id from the login response — never the prior guest id.
  const loggedInUserId = userData?.id;
  dispatch({ type: "LOGIN_SUCCESS", payload: userData });
  safeSetCurrentUser(JSON.stringify({ ...userData, visitor_id: getVisitorId() }));
  cartDispatch(updateLoyalityPoints(userData?.user_points));
  if (loggedInUserId != null) {
    // Same analytics/identity as normal sign-in (`login()` + login.tsx success effect).
    // Ids always come from the login response, never the prior guest session.
    branch.setIdentity(
      `${loggedInUserId}`,
      function (err, data) {
        console.log(err, data);
      }
    );
    TagManager.dataLayer({
      dataLayer: {
        event: 'login',
        login_method: loginMethod,
        new_user_id: loggedInUserId,
        user_email: userData.email,
        user_phone: userData?.phone
      },
    });
    TagManager.dataLayer({ dataLayer: { user_id: loggedInUserId } });
    brazeSetUser(String(loggedInUserId));
    trackLogin({
      userData,
      isItMobile,
      loginMethod,
      isAutoLogin: true,
    });
    // brazeLogCustomEventLoyaltySignIn(isItMobile, loginMethod);
    try {
      localStorage.removeItem(
        `ab.storage.messagingSessionStart.${process.env.REACT_APP_BRAZE_API_KEY}`
      );
      openSession();
    } catch {
      // Braze SDK may be unavailable; login session setup should not fail checkout.
    }
  }
  if (!isCheckoutLogin) syncCartOnLogin(cartDispatch);
}

export function logout(dispatch, cartDispatch) {
  queryClient.clear();
  dispatch({ type: "LOGOUT" });
  cartDispatch(resetCart());
  cartDispatch(resetCheckout());
  cartDispatch(updateTrackOrder(false));
  branch.logout();
  cartDispatch(updateLoyalityPoints(0));
  localStorage.setItem(
    CONSTANT.CURRENT_USER,
    JSON.stringify({ visitor_id: getVisitorId(), logged_out: true })
  );
  TagManager.dataLayer({ dataLayer: { user_id: null }});
}

export function unauthorizeLogout(dispatch) {
  queryClient.clear();
  dispatch(resetCart())
  dispatch(isLogoutAction())
  dispatch(resetCheckout())
  dispatch(updateTrackOrder(false));
  dispatch(updateLoyalityPoints(0));
  branch.logout();
  localStorage.setItem(
    CONSTANT.CURRENT_USER,
    JSON.stringify({ visitor_id: getVisitorId() })
  );
  TagManager.dataLayer({ dataLayer: { user_id: null }});
}

// generate the new guest customer in case of refresh token expires 
export async function initializeGuestUser(dispatch) {
  dispatch(dispatch({ type: "LOGOUT" }))      
  dispatch(resetCart())
  localStorage.setItem(
    CONSTANT.CURRENT_USER,
    JSON.stringify({ visitor_id: getVisitorId() })
  )
}

export async function socialSignIn(dispatch, loginPayload, signInName, cartDispatch, setLocationCallback, isCheckoutLogin = false, locationId = null, orderType = null, pulseLoginContext?: TrackLoginContext){
  try {
    let signInLink = ""
    switch (signInName) {
      case "GOOGLE_SIGNIN":
        signInLink = CONSTANT.GOOGLE_SIGNIN
            break;
      case "FACEBOOK_SIGNIN":
        signInLink = CONSTANT.FACEBOOK_SIGNIN
            break;
      case "APPLE_SIGNIN":
        signInLink= CONSTANT.APPLE_SIGNIN
    }
    dispatch({ type: "REQUEST_LOGIN" });
    //TODO: relace post call later
    const visitorId = getVisitorId()
    const newLoginPayload = attachKioskIdToSocialLoginPayloadIfSessionNotExpired(loginPayload);

    newLoginPayload["visitor_id"] = visitorId
    let response = await axiosNoInterceptor.post(
      `${CONSTANT.CUSTOMER_MICRO_SERVICE}${signInLink}`,
      newLoginPayload
    );

    if (response.data.status) {
      dispatch({ type: "LOGIN_SUCCESS", payload: response.data.data });
      safeSetCurrentUser(JSON.stringify({ ...response.data.data, visitor_id: getVisitorId() }));
      cartDispatch(updateLoyalityPoints(response?.data?.data?.user_points));
      if (response.data.data.is_new_user) {
        await brazeSetUser(response.data.data.id);
        // if (signInName === "GOOGLE_SIGNIN") {
        //   brazeLogCustomEventLoyaltyAccountCreated(response.data.data, "Gmail");
        // } else if (signInName === "APPLE_SIGNIN") {
        //   brazeLogCustomEventLoyaltyAccountCreated(response.data.data, "Apple");
        // }
      }
      branch.setIdentity(
        `${response.data.data.id}`,
        function (err, data) {
          console.log(err, data);
        }
      );
      TagManager.dataLayer({
        dataLayer: {
          event: 'login',
          login_method: signInName,
          new_user_id: response.data.data.id,
          user_email: response.data.data.email,
          user_phone: response?.data?.data?.phone
        },
      })
      if (!response.data.data.is_new_user) {
        const isItMobile =
          loginPayload?.platform === "MobileWeb" ||
          loginPayload?.user?.platform === "MobileWeb";
        trackLogin({
          userData: response.data.data,
          isItMobile,
          loginMethod: mapSocialSignInToLoginMethod(signInName),
          ...(pulseLoginContext ?? { isCheckoutLogin }),
        });
        // if (signInName === "GOOGLE_SIGNIN") {
        //   brazeLogCustomEventLoyaltySignIn(isItMobile, "Gmail");
        // } else if (signInName === "APPLE_SIGNIN") {
        //   brazeLogCustomEventLoyaltySignIn(isItMobile, "Apple");
        // }
      }
      if (!isCheckoutLogin) syncCartOnLogin(cartDispatch, locationId, orderType);
    }
  } catch (error) {
    Toast_Func({ status: false, message: error.response.data.errors[0] });
  }
}

const getGuestUserErrorMessage = (error: any): string =>
  error?.response?.data?.data?.errors?.[0]
  || error?.response?.data?.errors?.[0]
  || error?.response?.data?.message
  || error?.message
  || "Guest user API failed";

const getGuestUserResponseErrorMessage = (response: any): string =>
  response?.data?.data?.errors?.[0]
  || response?.data?.errors?.[0]
  || response?.data?.message
  || "Guest user API returned unsuccessful status";

export async function guestLogin(dispatch, cartDispatch, loginPayload: { visitor_id?: string } = {}) {
  let visitor_id = loginPayload?.visitor_id || getVisitorId();
  if (!visitor_id) {
    visitor_id = uuidv4();
    safeSetCurrentUser(JSON.stringify({ ...getUser(), visitor_id }));
  }
  const payload = { ...loginPayload, visitor_id };

  try {
    dispatch({ type: "REQUEST_LOGIN" });
    const response = await axiosNoInterceptor.post(`${CONSTANT.CUSTOMER_MICRO_SERVICE}/guest-customer` , payload);
    if (response.data.status) {
      dispatch({ type: "LOGIN_SUCCESS", payload: response.data.data });
      brazeSetUser(response?.data?.data?.id)
      safeSetCurrentUser(JSON.stringify(response?.data?.data));
      syncCartOnLogin(cartDispatch);
      return true;
    }

    const errorMessage = getGuestUserResponseErrorMessage(response);
    bugSnagNotifyAPIError("Guest User API", payload, `Guest user login failed: ${errorMessage}`);
    return false;
  } catch (error) {
    const errorMessage = getGuestUserErrorMessage(error);
    bugSnagNotifyAPIError(
      "Guest User API",
      { ...payload, status: error?.response?.status },
      `Guest user login failed: ${errorMessage}`
    );
    dispatch({
      type: "LOGIN_ERROR",
      error: error?.response?.data?.data?.errors[0],
    });
    return false;
  }
}